/** Kommer ihåg vilket språk besökaren valt, så vi kan erbjuda samma språk nästa gång. */

import type { Locale } from "./i18n";

const KEY = "sis-locale";
const MAX_AGE = 60 * 60 * 24 * 365; // ett år

function isLocale(value: string | null | undefined): value is Locale {
  return value === "sv" || value === "en" || value === "es";
}

/** Läser sparat språkval, eller null om besökaren aldrig valt. */
export function getLocalePreference(): Locale | null {
  if (typeof window === "undefined") return null;
  try {
    const stored = localStorage.getItem(KEY);
    if (isLocale(stored)) return stored;
  } catch {
    /* ignorera */
  }
  const match = typeof document !== "undefined" ? document.cookie.match(/(?:^|; )sis-locale=([^;]+)/) : null;
  const fromCookie = match?.[1];
  return isLocale(fromCookie) ? fromCookie : null;
}

/** Sparar besökarens språkval i ett år. */
export function setLocalePreference(locale: Locale) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(KEY, locale);
  } catch {
    /* ignorera */
  }
  try {
    document.cookie = `${KEY}=${locale}; path=/; max-age=${MAX_AGE}; samesite=lax`;
  } catch {
    /* ignorera */
  }
}
